import axios from "axios";

//IMPORT API ROUTE URL
import { GET_RESOURCE_RECOMMENDATION_HISTORY_ROUTE } from "./apiRoutes";

const getRecommendationHistoryByResource = (resource_slug, user_slug) => {
  var postData = new FormData();

  postData.append("rm_slug", user_slug);
  postData.append("resource_slug", resource_slug);

  return axios
    .post(GET_RESOURCE_RECOMMENDATION_HISTORY_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getRecommendationHistoryByResource;
